import { getClinicStructuredData } from "./clinic";

export function getBoulderStructuredData() {
  return getClinicStructuredData("boulder", [
    { name: "Locations", path: "/locations/" },
    { name: "Colorado", path: "/locations/colorado/" },
    { name: "Boulder", path: "/locations/colorado/boulder/" },
  ]);
}
